document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM fully loaded');
    // redirect customer's first session visit to register page if not an approved customer
    if (window.customerLoggedIn && !window.customerB2B && !localStorage.getItem('pendingRedirected')) {
      localStorage.setItem('pendingRedirected', 'true');
      window.location.href = '/account/register';
    }

    // when customer clicks on "Order Search" button:
    // 1.) if not logged in, redirect to login page
    // 2.) if logged in, but not registered, redirect to register page
    // 3.) if logged in and registered, redirect to order search page
    let orderSearchForms = document.querySelectorAll(".order-tracking form");
    if(orderSearchForms){
      orderSearchForms.forEach(orderSearchForm => {
        orderSearchForm.addEventListener("submit", e => {
          if (!window.customerLoggedIn) {
            e.preventDefault();
            const input = orderSearchForm.querySelector('.order-tracking-input');
            const searchOrderNumber = input?.value?.trim() || '';
            window.location.href = `/customer_authentication/login?return_to=%2Faccount%3Forder%3D${searchOrderNumber}`;
          } else if (!window.customerB2B) {
            e.preventDefault();
            window.location.href = "/account/register";
          }
        });
      });
    }
    
    const aircraftForm = document.getElementById('aircraftForm');
    if (aircraftForm) {
      aircraftForm.addEventListener('submit', function (e) {
        e.preventDefault();
        calculateValues();
      });
    }

    const calculateButton = document.querySelector("#calculate");
    if (calculateButton) {
      calculateButton.addEventListener('click', function (e) {
        e.preventDefault();
        calculateValues();
      });
    }
  
    function calculateValues() {
      const flowCoefficient = 0.657;
      const insideDiameterOfLine = 2.067;
      const unknownCoefficient = 53.35;
    
      const psiInput = parseFloat(document.getElementById("psiInput").value);
      const pressureInput = parseFloat(document.getElementById("pressureInput").value);
      const temperatureInput = parseFloat(document.getElementById("temperatureInput").value);
    
      // Validate input
      if (isNaN(psiInput) || isNaN(pressureInput) || isNaN(temperatureInput)) {
        return;
      }
    
      const staticPressureOfLine = psiInput + 14.7; // psia
      const temperature = temperatureInput + 460;   // Rankine
    
      // Flow (SCFM)
      const QaFlow = 128.8 * flowCoefficient * Math.pow(insideDiameterOfLine, 2);
      const QbFlow = Math.sqrt((staticPressureOfLine * pressureInput) / temperature);
      const flow = QaFlow * QbFlow;
    
      // Air Density
      const airDensity = (144 * staticPressureOfLine) / (unknownCoefficient * temperature);
    
      // Mass Flow (lb/hr)
      const QaMass = 359.1 * flowCoefficient * Math.pow(insideDiameterOfLine, 2);
      const QbMass = Math.sqrt(airDensity * pressureInput);
      const massFlowPerHour = QaMass * QbMass;
    
      // Mass Flow (lb/min)
      const massFlowPerMin = massFlowPerHour / 60;
    
      // Show results
      document.getElementById("Q").value = Math.round(flow);
      document.getElementById("Qm").value = Math.round(massFlowPerHour);
      document.getElementById("Qmm").value = (Math.round(massFlowPerMin * 10) / 10).toFixed(1);
    }
  });